"use client";

import { AlternatingSection } from "@/components/shared/alternating_section";
import { CloudflareStreamVideo } from "@/components/shared/CloudflareStreamVideo";
import { FeatureHeroSection } from "@/components/shared/feature_hero_section";
import { useParams } from "next/navigation";
import { get__video_for_locale } from "@/constants/videos";

export default function LecturersPage() {
    const params = useParams();
    const locale = params?.locale as string || 'en-gb';

    return (
        <main className="pt-4 sm:pt-6 md:pt-8 marketing-root">
            <div className="flex w-full flex-col items-center">

                <FeatureHeroSection
                    title="Reduce Your Workload with"
                    highlightedText=" our Smart-Support Tools"
                    description={`Without any changes to your teaching methods, StudyStash reduces student queries and provides real-time insights to help you tailor your lessons.`}
                    buttonText="Join the pilot"
                    buttonHref="/pilot-program"
                    secondButtonText="Book a demo"
                    secondButtonHref="/book-a-demo"
                    showDemoModal={false}
                    category=""
                    icon=""
                    iconAlt=""
                />

                <div className="relative w-full mt-32 sm:mt-48 md:mt-64">
                    <div id="video" className="relative mx-auto w-full max-w-4xl px-4 sm:px-6 py-12 sm:py-16 md:py-20">
                        <div className="w-full overflow-x-auto rounded-xl shadow-lg ring-1 ring-black/5 backdrop-blur-sm">
                            <CloudflareStreamVideo
                                uid={get__video_for_locale(locale, "LECTURER_EXPLAINER_VIDEOS")}
                                poster={"https://studystash.com/lecturer_video.jpg"}
                            />
                        </div>
                    </div>
                </div>

                <div className="relative w-full pt-24 sm:pt-32 pb-24 sm:pb-32">
                    <div className="absolute left-0 top-[-30px] sm:top-[-50px] md:top-[240px] w-full h-1/2 pointer-events-none z-0 opacity-60 sm:opacity-80 md:opacity-100">
                        <img
                            src="/left-right-loops.svg"
                            alt="Illustration of the StudyStash teaching-learning loop"
                            className="w-full h-full object-contain"
                        />
                    </div>

                    <div className="relative z-10">
                        <AlternatingSection
                            sections={[
                                {
                                    title: "Reduce your workload",
                                    content: "Cut down on 4 a.m. emails and classroom interruptions. With StudyChat answering thousands of student questions during class and independent study, faculty spend less time troubleshooting and more time teaching.",
                                    image: {
                                        src: "/lecturer-classroom.jpg",
                                        alt: "Teacher engaging with students in classroom"
                                    }
                                },
                                {
                                    title: "Enhance the In-Class Experience",
                                    content: "StudyStash creates formative assessments and revision materials for your students, while giving you clear insights into their understanding so you can target support where it's needed most—without adding to your workload.",
                                    image: {
                                        src: "/teacher-in-classroom.jpg",
                                        alt: "Teacher in a modern classroom setting"
                                    },
                                    button: {
                                        text: "Start your pilot program",
                                        variant: "primary" as const,
                                        size: "lg" as const,
                                        onClick: () => window.location.href = '/pilot-program'
                                    }
                                }
                            ]}
                        />
                    </div>
                </div>
            </div>
        </main>
    );
}
